<div class="mb-card"
     *ngIf="(wishList$ | async) as wishlist">
  <h3 class="my-3">{{wishlist.entries?.length}} {{'mbMyAccount.wishlist.totalItems' | cxTranslate}}</h3>
  <ng-container *ngIf="wishlist.entries?.length > 0; else noFavorites">
    <mb-myaccount-wish-list-item *ngFor="let entry of wishlist?.entries"
                                 [wishlistEntry]="entry">
    </mb-myaccount-wish-list-item>

  </ng-container>
  <ng-template #noFavorites>
    <mb-myaccount-no-data-card
      [message]="'mbMyAccount.wishlist.empty.message' | cxTranslate"
      [link]="'/'"
      [linkText]="'mbMyAccount.wishlist.empty.linkText' | cxTranslate">
    </mb-myaccount-no-data-card>
  </ng-template>
  <mb-myaccount-button [path]="'myAccount'"
                       [textTranslationPath]="'mbMyAccount.backToMyAccount'"
  ></mb-myaccount-button>
</div>
<mb-myaccount-mobile-navigation></mb-myaccount-mobile-navigation>

